/**
 * VideoEffectsPanel — Appearance filters only (CSS, zero lag)
 */

import React from "react";
import { useVideoEffects } from "hooks/useVideoEffects";

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

  .vep-root {
    display: flex;
    flex-direction: column;
    height: 100%;
    font-family: 'Inter', system-ui, sans-serif;
    background: #0b1120;
    color: #dbe4f8;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #1a2540 transparent;
  }

  .vep-section { padding: 20px; }

  .vep-section-title {
    font-size: 10.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #4a5f82;
    margin: 0 0 16px;
  }

  /* ── Filter grid ── */
  .vep-filters {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }

  .vep-filter-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    cursor: pointer;
  }

  .vep-filter-preview {
    width: 100%;
    aspect-ratio: 16/9;
    border-radius: 12px;
    background: linear-gradient(135deg, #1e2d4a 0%, #0f1629 100%);
    border: 2px solid transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    transition: border-color 0.15s, transform 0.15s;
    overflow: hidden;
    position: relative;
  }

  .vep-filter-item:hover .vep-filter-preview { transform: scale(1.04); }
  .vep-filter-item.vep-active .vep-filter-preview {
    border-color: #22d3ee;
    box-shadow: 0 0 12px rgba(34,211,238,0.2);
  }

  .vep-filter-name {
    font-size: 11px;
    font-weight: 500;
    color: #6b7fa8;
    text-align: center;
  }

  .vep-filter-item.vep-active .vep-filter-name { color: #22d3ee; }

  /* Active checkmark */
  .vep-filter-check {
    position: absolute;
    top: 5px; right: 5px;
    width: 18px; height: 18px;
    background: #22d3ee;
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    font-size: 10px;
    color: #04111a;
    font-weight: 800;
  }

  /* Info box */
  .vep-info {
    margin: 0 20px 20px;
    padding: 12px 14px;
    background: rgba(34,211,238,0.05);
    border: 1px solid rgba(34,211,238,0.12);
    border-radius: 10px;
    font-size: 12px;
    color: #6b7fa8;
    line-height: 1.6;
  }

  .vep-info strong { color: #8b9dc3; }
`;

const FILTER_EMOJI = {
  none: "😊",
  bright: "☀️",
  cinematic: "🎬",
  grayscale: "🖤",
  warm: "🌅",
  cool: "❄️",
};

let _inj = false;
const injectStyles = () => {
  if (_inj) return;
  const s = document.createElement("style");
  s.textContent = STYLES;
  document.head.appendChild(s);
  _inj = true;
};

const VideoEffectsPanel = () => {
  injectStyles();
  const { activeFilterId, applyFilter, FILTERS } = useVideoEffects();

  return (
    <div className="vep-root">
      <div className="vep-section">
        <p className="vep-section-title">Appearance Filter</p>
        <div className="vep-filters">
          {FILTERS.map((f) => {
            const active = activeFilterId === f.id;
            return (
              <div
                key={f.id}
                className={`vep-filter-item${active ? " vep-active" : ""}`}
                onClick={() => applyFilter(f)}
              >
                <div
                  className="vep-filter-preview"
                  style={{ filter: f.css !== "none" ? f.css : undefined }}
                >
                  {FILTER_EMOJI[f.id] || "✨"}
                  {active && <div className="vep-filter-check">✓</div>}
                </div>
                <span className="vep-filter-name">{f.label}</span>
              </div>
            );
          })}
        </div>
      </div>

      {/* <div className="vep-info">
        <strong>GPU accelerated</strong> - filters apply instantly with zero performance impact.
        Your video appears filtered to everyone in the call.
      </div> */}
    </div>
  );
};

export default VideoEffectsPanel;